import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { FlyIn } from '@ff-os/shared-react/components/fly-in/FlyIn';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { NumberInputField } from '@ff-os/shared-react/components/input/number-input/NumberInputField';
import { WindowStackItem } from '@ff-os/shared-react/context/window-stack/WindowStackItem';
import { actions as photoActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { selectPhotoStatusById, selectQuantityById } from '../../../_redux-photos';
import { ChangeVariantWindow } from '../../change-variant-window/ChangeVariantWindow';
import { PhotoPrintCropWindow } from '../../photo-print/photo-print-crop/PhotoPrintCropWindow';
import styles from './PhotoPrintMobile.module.scss';

const _PhotoPrintMobileOverlay = ({
    isOpen, setOpen,
    quantity, setQuantity,
    removePhoto, photoId, onMoveOrCopy
}: Props) => {

    const { t } = useTranslation();

    const [isCropOpen, setCropOpen] = useState(false);
    const [isEditOpen, setEditOpen] = useState(false);

    const closeMenuAnd = (close: () => void) => () => {
        setOpen(false);
        close();
    };

    return (
        <>
            {isOpen && (
                <WindowStackItem>
                    <FlyIn from='bottom' hide={() => setOpen(false)}>
                        <FlyIn.MenuItem className={styles.numberItem}>
                            <NumberInputField small
                                className={styles.number}
                                value={quantity} commit={setQuantity} label='lol' />
                        </FlyIn.MenuItem>

                        <FlyIn.MenuItem
                            icon={<Icon type='general-ui-crop' />}
                            onClick={() => setCropOpen(true)}>
                            {t('image_uploader.edit')}
                        </FlyIn.MenuItem>

                        <FlyIn.MenuItem
                            icon={<Icon type='general-ui-brush' />}
                            onClick={() => setEditOpen(true)}>
                            {t('photo_prints.change_variant')}
                        </FlyIn.MenuItem>

                        <FlyIn.MenuItem
                            icon={<Icon className={styles.deleteIcon} type='general-ui-bin' />}
                            className={styles.deleteButton}
                            onClick={removePhoto}>
                            {t('commons.delete')}
                        </FlyIn.MenuItem>
                    </FlyIn>
                </WindowStackItem>
            )}

            {isCropOpen && (
                <WindowStackItem>
                    <PhotoPrintCropWindow photoId={photoId} close={closeMenuAnd(() => setCropOpen(false))} />
                </WindowStackItem>
            )}

            {isEditOpen && (
                <WindowStackItem>
                    <ChangeVariantWindow withMethod
                        photoId={photoId} onSave={onMoveOrCopy}
                        close={closeMenuAnd(() => setEditOpen(false))} />
                </WindowStackItem>
            )}
        </>
    );
};

type OwnProps = {
    photoId: string;
    isOpen: boolean;
    setOpen: (value: boolean) => void;
    onMoveOrCopy: () => void;
};

type Props = OwnProps & {
    quantity: number;
    setQuantity: (quantity: number) => void;
    removePhoto: () => void;
    status: PhotoPrintsJson.ProcessedPhoto['status'];
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    quantity: selectQuantityById(state, ownProps.photoId),
    status: selectPhotoStatusById(state, ownProps.photoId)!
});

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, ownProps: OwnProps) => ({
    removePhoto: () => dispatch(photoActions.remove(ownProps.photoId)),
    setQuantity: (quantity: number) => dispatch(photoActions.setQuantity({
        photoId: ownProps.photoId,
        quantity: quantity
    }))
});

export const PhotoPrintMobileOverlay = connect(
    mapStateToProps,
    mapDispatchToProps
)(_PhotoPrintMobileOverlay);